import clsx from 'clsx';
import type { SlaBadge as SlaBadgeData } from '@/api/mrn';

const CLASS = {
  ok: 'bg-success/15 text-success border-success/30',
  warn: 'bg-warning/15 text-warning border-warning/30',
  overdue: 'bg-danger/15 text-danger border-danger/30',
  inactive: 'bg-white/[0.04] text-[var(--text-muted)] border-white/10',
};

const LABEL = {
  ok: 'OK',
  warn: '⚠ Warn',
  overdue: '🔴 Overdue',
  inactive: '—',
};

export function SlaBadge({ sla }: { sla: SlaBadgeData | null | undefined }) {
  if (!sla) return null;
  return (
    <span
      title={`${sla.elapsedHours.toFixed(1)}h / ${sla.hours}h (${sla.pct}%)`}
      className={clsx(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-bold tracking-wide',
        CLASS[sla.state],
      )}
    >
      {LABEL[sla.state]}
    </span>
  );
}
